import { DestroyRef, inject } from "@angular/core";

export function registerClassOnWindow(key: string, value: any) {
  // return;
  window[key] = value;
  const destroyRef = inject(DestroyRef);
  destroyRef.onDestroy(() => {
    delete window[key];
  });
}